import React, { useCallback, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeUsersTab, resetParams } from '../../redux/user-management/userManagementReducer';
import CommonPage from '../../components/common-page/CommonPage';
import CommonTabs from '../../components/common-tabs/CommonTabs';
import useUsersTabs from './useUsersTabs';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import SystemUsers from './system-users/SystemUsers';
import DemoUsers from './demo-recr8/DemoUsers';

const Users = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state) => state.userManagement.usersTab);

  const tabs = useUsersTabs();

  const handleChangeTabs = useCallback(
    (_, newTab) => {
      dispatch(changeUsersTab(newTab));
    },
    [dispatch],
  );

  useEffect(() => {
    return () => {
      dispatch(resetParams());
    };
  }, [dispatch]);

  return (
    <CommonPage>
      <CommonTabs tabs={tabs} value={selectedTab} onChange={handleChangeTabs} />

      <CommonTabPanel value={selectedTab} index={0}>
        <SystemUsers />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={1}>
        <DemoUsers />
      </CommonTabPanel>
    </CommonPage>
  );
};

export default memo(Users);
